import { httpClient } from '../httpClient';
import {
  IAvatarTrain, IAvatarVideo,
  CreateAvatarTrainRequest, CreateAvatarVideoRequest,
  AvatarTrainQuery, AvatarVideoQuery,
  PaginatedResponse, PaginationQuery
} from '@packages/global';

export const avatarTrainApi = {
  getPageList(params: PaginationQuery<AvatarTrainQuery>): Promise<PaginatedResponse<IAvatarTrain>> {
    return httpClient.post<PaginatedResponse<IAvatarTrain>>('/user/avatarTrains/page', params);
  },
  create(data: CreateAvatarTrainRequest): Promise<IAvatarTrain> {
    return httpClient.post<IAvatarTrain>('/user/avatarTrains', data);
  },
  getById(id: string): Promise<IAvatarTrain> {
    return httpClient.get<IAvatarTrain>(`/user/avatarTrains/${id}`);
  },
  retrain(id: string): Promise<IAvatarTrain> {
    return httpClient.post<IAvatarTrain>(`/user/avatarTrains/${id}/retrain`, {});
  },
  delete(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/avatarTrains/${id}`);
  }
};

export const avatarVideoApi = {
  getPageList(params: PaginationQuery<AvatarVideoQuery>): Promise<PaginatedResponse<IAvatarVideo>> {
    return httpClient.post<PaginatedResponse<IAvatarVideo>>('/user/avatarVideos/page', params);
  },
  create(data: CreateAvatarVideoRequest): Promise<IAvatarVideo> {
    return httpClient.post<IAvatarVideo>('/user/avatarVideos', data);
  },
  getById(id: string): Promise<IAvatarVideo> {
    return httpClient.get<IAvatarVideo>(`/user/avatarVideos/${id}`);
  },
  cancel(id: string): Promise<void> {
    return httpClient.post<void>(`/user/avatarVideos/${id}/cancel`);
  },
  delete(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/avatarVideos/${id}`);
  }
};
